import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CoreService } from './../../../core/services/core.service';
import { ReportingYearsService } from './../../../core/services/reporting-years.service';
import {
  NOMINATION_REPORTING_YEAR,
  REPORTING_WORKFLOW_YEAR,
  REPORTING_YEAR,
} from './../../constants/constant';
import { Dropdown } from './../../models/dropdown.model';

@Component({
  selector: 'app-reporting-cycles-dropdown',
  templateUrl: './reporting-cycles-dropdown.component.html',
  styleUrls: ['./reporting-cycles-dropdown.component.scss'],
})
export class ReportingCyclesDropdownComponent implements OnInit, AfterViewInit {
  yearsOptions: Dropdown[];
  yearsFormControl = new FormControl();
  constructor(
    private reportingYearsService: ReportingYearsService,
    private router: Router,
    private coreService: CoreService,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.yearsOptions =
      this.reportingYearsService.baselineReportingCycleOptions;

    this.onSelectDeposit();

    if (
      this.router.url.split(`${REPORTING_YEAR}/`) &&
      this.router.url.split(`${REPORTING_YEAR}/`).length &&
      this.reportingYearsService.baselineReportingCycleOptions.findIndex(
        (x: Dropdown) =>
          x.dropdownDesc === this.router.url.split(`${REPORTING_YEAR}/`)[1],
      ) > -1
    ) {
      // this.reportingYearsService.selectedYear = this.router.url.split(`${REPORTING_YEAR}/`)[1];
      this.yearsFormControl.setValue(
        this.router.url.split(`${REPORTING_YEAR}/`)[1],
      );
    } else if (
      this.router.url.split(`${REPORTING_WORKFLOW_YEAR}/`) &&
      this.router.url.split(`${REPORTING_WORKFLOW_YEAR}/`).length &&
      this.reportingYearsService.baselineReportingCycleOptions.findIndex(
        (x: Dropdown) =>
          x.dropdownDesc ===
          this.router.url.split(`${REPORTING_WORKFLOW_YEAR}/`)[1],
      ) > -1
    ) {
      // this.reportingYearsService.selectedYear = this.router.url.split(`${REPORTING_YEAR}/`)[1];
      this.yearsFormControl.setValue(
        this.router.url.split(`${REPORTING_WORKFLOW_YEAR}/`)[1],
      );
    } else if (
      this.router.url.split(`${NOMINATION_REPORTING_YEAR}/`) &&
      this.router.url.split(`${NOMINATION_REPORTING_YEAR}/`).length &&
      this.reportingYearsService.baselineReportingCycleOptions.findIndex(
        (x: Dropdown) =>
          x.dropdownDesc ===
          this.router.url.split(`${NOMINATION_REPORTING_YEAR}/`)[1],
      ) > -1
    ) {
      // this.reportingYearsService.selectedYear = this.router.url.split(`${REPORTING_YEAR}/`)[1];
      this.yearsFormControl.setValue(
        this.router.url.split(`${NOMINATION_REPORTING_YEAR}/`)[1],
      );
    } else {
      this.yearsFormControl.setValue(
        sessionStorage.getItem('currentReportingCycleYear'),
      );
      this.reportingYearsService.selectedYear = sessionStorage.getItem(
        'currentReportingCycleYear',
      );
    }
  }

  onSelectDeposit(): void {
    this.yearsFormControl.valueChanges.subscribe((value) => {
      this.reportingYearsService.selectedYear = value;
      this.reportingYearsService.selectedYearSubject.next(value);
    });
  }
}
